import { configureStore } from '@reduxjs/toolkit';
import contentComplianceReducer from '../features/contentCompliance/contentComplianceSlice';
import authReducer from '../features/auth/authSlice';
import notificationsReducer from '../features/notifications/notificationsSlice';
import billingReducer from '../features/billing/billingSlice';
import { analyticsListener } from '../analytics/analyticsListener';
import { setAnalyticsUser } from '../analytics/analytics';

export const store = configureStore({
  reducer: {
    contentCompliance: contentComplianceReducer,
    auth: authReducer,
    notifications: notificationsReducer,
    billing: billingReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(analyticsListener.middleware),
});

// A returning signed-in user restored from localStorage: tag their session.
const { auth } = store.getState();
if (auth?.isAuthenticated && auth?.user?.userId) {
  setAnalyticsUser(auth.user.userId);
}
